import React, { useState, useEffect, useRef } from 'react';
import { useTheme } from '@material-ui/core/styles';

const Clock = ({ timezone, country, always_display }) => {
  const theme = useTheme();
  const [time, setTime] = useState(getCurrentTime());
  const clockContainerRef = useRef(null);

  useEffect(() => {
    const interval = setInterval(() => {
      setTime(getCurrentTime());
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, []);

  useEffect(() => {
    function handleResize() {
      setTime(getCurrentTime());
    }
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  function getCurrentTime() {
    const now = new Date();
    let country_timezone=country.main_timezone;
    let nt=JSON.parse(timezone);
    if(nt.length>1 && country_timezone!=undefined && nt.includes(country_timezone)==true){nt=country_timezone;}else{nt=nt[0];}
    if (nt === Intl.DateTimeFormat().resolvedOptions().timeZone) {
      return null; // Return null if the timezone is the current one
    }
    const timeOptions = {
      timeZone: nt,
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
      hour12: false,
    };
    const currentZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const localTimeOptions = {
      timeZone: currentZone,
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
      hour12: false,
    };
    const localTime = now.toLocaleTimeString('en-US', localTimeOptions);
    const contactTime=now.toLocaleTimeString('en-US', timeOptions);

    if(localTime==contactTime && always_display!=true){return null;}
    else{return contactTime;}
  }

  useEffect(() => {
    setTime(getCurrentTime());
  }, [timezone]);

  const clockContainerWidth = clockContainerRef.current
    ? clockContainerRef.current.offsetWidth
    : null;

  const fontSize = clockContainerWidth ? Math.floor(clockContainerWidth / 8) * 1.5 : 0;

  const clockStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: theme.palette.primary.main,
    color: '#fff',
    padding: 0,
    width: '100%',
    maxWidth: '100px',
    fontSize: `${fontSize}px`,
    letterSpacing: '-0.1em',
    fontFamily: 'monospace',
    fontWeight: 'bold',
    textShadow: '1px 1px 3px rgba(0, 0, 0, 0.3)',
  };

  if(time==null){return null;}
  return (
    <span style={{ width: '100%' }}>
      <div ref={clockContainerRef} style={clockStyle}>
        {time}
      </div>
    </span>
  );
};

export default Clock;
